import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Download } from 'lucide-react';
import { CFA_INFO } from '../data/constants';
import { toast } from 'sonner';
export function Contact() {
  const handleDownloadClick = (e: React.MouseEvent) => {
    e.preventDefault();
    toast.info('Le catalogue sera bientôt disponible au téléchargement.');
  };
  return <div className="flex flex-col w-full" data-id="element-1030">
      <PageHeader title="Contactez-nous" subtitle="Une question sur nos formations, l'alternance ou notre CFA ? Notre équipe est à votre disposition." data-id="element-1031" />
      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-1032">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1033" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-1034">
          <div className="grid lg:grid-cols-3 gap-16" data-id="element-1035">
            {/* Contact Info */}
            <div className="lg:col-span-1 space-y-10" data-id="element-1036">
              <div data-id="element-1037">
                <h2 className="text-3xl font-extrabold font-heading text-primary-dark mb-8" data-id="element-1038">
                  Nos coordonnées
                </h2>
                <div className="space-y-8" data-id="element-1039">
                  <div className="flex items-start gap-5 group" data-id="element-1040">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1041">
                      <MapPin className="w-6 h-6 text-brand-orange animate-soft-bounce" data-id="element-1042" />
                    </div>
                    <div data-id="element-1043">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1044">
                        Adresse
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1045">
                        {CFA_INFO.address}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5 group" data-id="element-1046">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1047">
                      <Phone className="w-6 h-6 text-brand-orange animate-soft-bounce" style={{
                      animationDelay: '0.2s'
                    }} data-id="element-1048" />
                    </div>
                    <div data-id="element-1049">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1050">
                        Téléphone
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1051">
                        {CFA_INFO.phone}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5 group" data-id="element-1052">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1053">
                      <Mail className="w-6 h-6 text-brand-orange animate-soft-bounce" style={{
                      animationDelay: '0.4s'
                    }} data-id="element-1054" />
                    </div>
                    <div data-id="element-1055">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1056">
                        Email
                      </h3>
                      <a href={`mailto:${CFA_INFO.email}`} className="text-primary font-medium hover:text-brand-orange transition-colors underline underline-offset-4" data-id="element-1057">
                        {CFA_INFO.email}
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-10 border-t border-slate-200" data-id="element-1058">
                <h2 className="text-2xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-1059">
                  Accès rapides
                </h2>
                <div className="flex flex-col gap-4" data-id="element-1060">
                  <Button className="w-full justify-start py-6 text-base bg-primary hover:bg-primary-dark text-white shadow-md" asChild data-id="element-1061">
                    <Link to="/candidater" data-id="element-1062">Candidater à une formation</Link>
                  </Button>
                  <Button variant="outline" className="w-full justify-start py-6 text-base border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" asChild data-id="element-1063">
                    <Link to="/entreprises" data-id="element-1064">Recruter un alternant</Link>
                  </Button>
                  <Button variant="secondary" className="w-full justify-start py-6 text-base bg-lavande text-primary-dark hover:bg-lavande/80 font-semibold" onClick={handleDownloadClick} data-id="element-1065">
                    <Download className="w-5 h-5 mr-3" data-id="element-1066" />
                    Télécharger le catalogue
                  </Button>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className="lg:col-span-2" data-id="element-1067">
              <Card className="border-none shadow-2xl bg-white overflow-hidden h-full min-h-[800px]" data-id="element-1068">
                <div className="h-2 w-full bg-gradient-to-r from-primary to-brand-orange" data-id="element-1069" />
                <CardContent className="p-0 h-full" data-id="element-1070">
                  <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSdRLYT0VfO_LX-YYiSPQlqEqRBbh85E9r9tEh_ECt_v__4ISQ/viewform?embedded=true" width="100%" height="2532" className="w-full min-h-[800px]" frameBorder="0" marginHeight={0} marginWidth={0} title="Formulaire de contact" data-id="element-1071">
                    Chargement du formulaire…
                  </iframe>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>;
}